import AIResult from './AIResult';

export default {
  ...AIResult,
  'More Tools': 'Công cụ khác',
  'W/L Presets': 'Cửa sổ ảnh đặt trước',
  'More Measure Tools': 'Công cụ đo khác',
  No: 'Không',
  Yes: 'Có',
  'No, do not ask again': 'Không, không hỏi lại',
  Quality: 'Chất lượng',
  Length: 'Thước đo',
  Reset: 'Đặt lại',
  Preview: 'Xem trước',
  'Select Source': 'Chọn nguồn',
  Cancel: 'Hủy',
  Download: 'Tải xuống',
  Sorry: 'Xin lỗi',
  Analyze: 'Phân tích',
  'Analyzing...': 'Đang phân tích...',

  'Normal Quality': 'Trung bình',
  'High Quality': 'Cao',

  '3D Rotate': 'Xoay 3D',

  'Adjust window': 'Điều chỉnh cửa sổ',

  Crosshairs: 'Vị trí tương quan',
  'Heart Rate': 'Nhịp tim',
  Duration: 'Khoảng thời gian',
  'Amplitude Deviation': 'Độ lệch biên độ',
  'QRS Axis': 'Trục điện tim',

  'Remove bed': 'Xóa giường',

  'Rectangle Scalpel': 'Cắt hình chữ nhật',
  'Freehand Scalpel': 'Cắt tự do',
  'Processing...': 'Đang xử lý...',
  'Loading Image Preview...': 'Đang tải ảnh xem trước...',

  'Current study (dicom)': 'Ca chụp (dicom)',
  'Current series (dicom)': 'Series hiện tại (dicom)',
  'Current instance (dicom)': 'Ảnh chụp hiện tại (dicom)',
  'Current image': 'Hình ảnh hiện tại',
  'Current instance': 'Ảnh chụp hiện tại',
  'Current series': 'Series hiện tại',
  'Current study': 'Ca chụp hiện tại',
  imageWidth: 'Chiều rộng ảnh (px)',
  imageHeight: 'Chiều cao ảnh (px)',
  'File Name': 'Tên tập tin',
  'File Type': 'Loại tập tin',
  'Keep Aspect Ratio': 'Giữ nguyên tỉ lệ',
  'Show Annotations': 'Kèm theo chú thích',

  'Select CAD Tool': 'Chọn công cụ CAD',

  // KeyImage/index
  'Capture Key Image': 'Chụp ảnh key image',

  // Reconstruct3D
  '3D Reconstruction': 'Dựng ảnh 3D',

  // MeasurementsList
  'Mammo right': 'Vú phải',
  'Mammo left': 'Vú trái',
  'Mammo R': 'Vú phải',
  'Mammo L': 'Vú trái',

  // SeriesSynchronization
  'Reference Line': 'Đường tham chiếu',
  'Synchronize Slice Position': 'Đồng bộ vị trí lát cắt',
  'Synchronize Zoom': 'Đồng bộ thu phóng',
  'Synchronize Pan': 'Đồng bộ di chuyển',
  'Synchronize Zoom & Pan': 'Đồng bộ thu phóng và di chuyển',
  'Synchronize Window Settings': 'Đồng bộ cửa sổ ảnh',

  Eraser: 'Tẩy',
  Acquired: 'Đã lấy',
  'Correction Scissors': 'Cắt tỉa',
  Axial: 'Trục',
  Brush: 'Bút lông',
  CINE: 'Duyệt ảnh',
  Circle: 'Vòng tròn',
  Coronal: 'Mặt phẳng vành',
  Elliptical: 'Elip',
  'Flip H': 'Lật ngang',
  'Flip V': 'Lật dọc',
  Freehand: 'Tự do',
  'DICOM Tags': 'Thẻ DICOM',
  'Computer-Aided Diagnosis': 'Hỗ trợ chẩn đoán',
  'DICOM Tag Browser': 'Thông tin thẻ DICOM',
  Info: 'Thông tin',
  'Download Image': 'Tải ảnh xuống',
  fileType: 'Loại tệp',

  Levels: 'Độ sáng',
  Manual: 'Thủ công',
  Probe: 'Điểm ảnh',
  'ROI Window': 'Cửa sổ ROI',
  Sagittal: 'Mặt phẳng đứng dọc',
  Themes: 'Giao diện',
  'N/C': 'AI không có kết luận',
  NFI: 'Cần thăm khám thêm',
  Select: 'Lựa chọn',
  Mass: 'Khối',

  'Grid Layout': 'Bố cục lưới',
  'Series Synchronization': 'Đồng bộ hóa series',
  'Stack Image Sync': 'Đồng bộ cửa sổ ảnh',
  'Reference Lines': 'Đường tham chiếu',
  'Rotate Right': 'Xoay Phải',
  'Rotate Right +90': 'Xoay Phải 90°',
  'Rotate Left': 'Xoay trái',
  'Flip Horizontally': 'Lật Ngang',
  'Flip Vertical': 'Lật Dọc',
  'Reset View': 'Đặt lại chế độ xem',
  'Reset view': 'Đặt lại chế độ xem',
  'Stack Scroll': 'Cuộn ảnh',
  'Invert Colors': 'Đảo ngược màu',
  Cine: 'Duyệt ảnh',
  Zoom: 'Phóng to',
  Presets: 'Bộ lọc',
  Pan: 'Di chuyển',
  Magnify: 'Phóng đại',
  'Delete DICOM Study': 'Xoá ca chụp DICOM',
  MPR: 'MPR',
  VR: 'VR',
  '3D Pan': 'Di chuyển 3D',
  '3D Zoom': 'Phóng to 3D',
  'Adjust Window': 'Điều chỉnh cửa sổ',
  'Remove Bed': 'Xoá giường',
  MIP: 'MIP',
  Print: 'In',
  'Dicom Tag Browser': 'Thông tin thẻ DICOM',
  CAD: 'CAD',
  'Window Level': 'Chỉnh độ sáng',
  Invert: 'Đảo ngược màu',
  Bidirectional: 'Thước đo hai chiều',
  Annotation: 'Chú thích',
  Angle: 'Đo Góc',
  'Cobb Angle': 'Góc Cobb',
  'Planar Freehand ROI': 'Vẽ tự do ROI',
  Polyline: 'Vẽ nhiều đoạn',
  Rectangle: 'Hình chữ nhật',
  Ellipse: 'Hình elip',
  Calibration: 'Hiệu chuẩn',
  ViewMode: 'Chế độ xem',
  WindowLevelTools: 'Chỉnh độ sáng',
  Rotation: 'Xoay ảnh',

  'Zoom In': 'Phóng to',
  'Zoom Out': 'Thu nhỏ',
  'Zoom to Fit': 'Phóng vừa màn hình',
  Window: 'Cửa sổ ảnh',
  'Clear Annotations': 'Xóa chú thích',
  'Open Report': 'Mở báo cáo',
  'Next Image': 'Ảnh tiếp theo',
  'Previous Image': 'Ảnh trước đó',
  'Previous Series': 'Series trước đó',
  'Next Series': 'Series tiếp theo',
  'Save Key Image': 'Lưu ảnh key image',
  'Delete DICOM': 'Xoá DICOM',
  'Show Bounding Boxes': 'Hiển thị kết quả AI',
  'Show Segmentations': 'Hiển thị kết quả AI',
  'Export Images': 'Xuất hình ảnh',
  'Please specify the dimensions and desired type for the output image.':
    'Vui lòng chỉ định kích thước và loại mong muốn của hình ảnh đầu ra.',
  Export: 'Xuất',
  'File format': 'Định dạng tệp',
  Image: 'Hình ảnh',
  Raw: 'Nguyên bản',
  'Image Size': 'Kích thước ảnh',
  'Current size': 'Kích thước hiện tại',
  Custom: 'Tuỳ chỉnh',
  Width: 'Chiều rộng',
  Height: 'Chiều cao',
  'Image preview': 'Xem trước hình ảnh',
  Save: 'Lưu',
  Series: 'Series',
  Search: 'Tìm kiếm',
  Keyword: 'Từ khoá',
  'VR might not work properly on low end device':
    'VR có thể không hoạt động bình thường trên thiết bị có cấu hình yếu',
  'MPR might not work properly on low end device':
    'MPR có thể không hoạt động bình thường trên thiết bị có cấu hình yếu',
  'Number of slices does not reach minimum requirement':
    'Số lát không đạt yêu cầu tối thiểu',
  'Open anyway': 'Vẫn mở',
  'Error Loading Image': 'Lỗi khi tải hình ảnh',
  Tag: 'Thẻ',
  Value: 'Giá trị',
  'This Segmentation is loaded in the segmentation panel':
    'Phân đoạn này được tải trong bảng phân đoạn',
  'Loading Segment': 'Đang tải đoạn',
  'Loading SEG ...': 'Đang tải SEG ...',
  'The image is currently unavailable': 'Dữ liệu hình ảnh chưa sẵn sàng',
  'Study not found': 'Không tìm thấy ca chụp',
  'The exam is currently unavailable': 'Dữ liệu ca chụp chưa sẵn sàng',
  'If reloading the page does not fix the problem, please contact the administrator for assistance.':
    'Nếu tải lại trang không khắc phục được sự cố, vui lòng liên hệ với quản trị viên để được trợ giúp.',

  'Video src/type not supported': 'Định dạng video không được hỗ trợ',
  'of type': 'loại',
  'Video of type': 'loại video',
  'is not supported.': 'không được hỗ trợ.',

  'Series is': 'Series là',
  tracked: 'theo dõi',
  untracked: 'không được theo dõi',
  'and can be viewed': 'và có thể được xem',
  'in the measurement panel': 'trong bảng đo lường',
  'Measurements for': 'Đo lường cho',
  series: 'series',
  'will not be shown in the': 'sẽ không được hiển thị trong',
  'measurements panel': 'bảng đo lường',
  Run: 'Chạy',
  'User Guide': 'Hướng dẫn sử dụng',
  'ROI Threshold Configuration': 'Cấu hình ngưỡng ROI',
  Segmentations: 'Phân đoạn',
  'Print DICOM': 'In DICOM',
  Active: 'Kích hoạt',
  Opacity: 'Độ mờ',
  'Inactive Segmentations': 'Phân đoạn không hoạt động',
  Size: 'Kích thước',
  'Add New Segmentation': 'Thêm phân khúc mới',
  CONTENT: 'NỘI DUNG',
  'panel placeholder': 'giữ chỗ bảng điều khiển',

  'Series is displayed': 'Series được hiển thị',
  'in viewport': 'trong chế độ xem',
  cancel: 'huỷ',
  'This structured report is not compatible':
    'Báo cáo có cấu trúc này không tương thích',
  'with this application.': 'với ứng dụng này.',
  'This structured report is currently read-only':
    'Báo cáo có cấu trúc này hiện ở dạng chỉ đọc',
  'because you are tracking measurements in':
    'bởi vì bạn đang theo dõi các phép đo lường trong',
  'another viewport.': 'một khung nhìn khác.',
  Click: 'Nhấp chuột',
  'to restore measurements.': 'để khôi phục các phép đo.',
  'No online PDF viewer installed':
    'Không có trình xem PDF trực tuyến nào được cài đặt',
  'Add Segment': 'Thêm đoạn',
  'Click LOAD to load segmentation.': 'Nhấp vào TẢI để tải phân đoạn.',
  'An error has occurred.': 'Có lỗi đã xảy ra.',
  'Loading...': 'Đang tải...',

  'Cut inside': 'Cắt bên trong',
  Del: 'Del',
  'Cut outside': 'Cắt bên ngoài',
  Enter: 'Enter',
  'Clear area': 'Xoá vùng đã vẽ',
  Esc: 'Esc',

  Paper: 'Trang',
  'Demographic Information': 'Thông tin người bệnh',
  'Print Type': 'Loại in',
  'DICOM PRINT': 'IN DICOM',
  'PAPER PRINT': 'IN TÀI LIỆU',
  'Save as PDF': 'Lưu dưới dạng PDF',
  'Save as PNG': 'Lưu dưới dạng PNG',
  'Save as Image': 'Lưu dưới dạng ảnh',
  Settings: 'Cài đặt',
  'Number Of Copies': 'Số bản sao',
  'Text Size': 'Cỡ chữ',
  Small: 'Nhỏ',
  Medium: 'Vừa',
  Large: 'Lớn',
  Orientation: 'Hướng',
  PORTRAIT: 'HƯỚNG DỌC',
  LANDSCAPE: 'HƯỚNG NGANG',
  'Film Size': 'Kích thước phim',

  Trim: 'Trim',
  NO: 'NO',
  YES: 'YES',

  'Medium Type': 'Medium Type',
  'CLEAR FILM': 'CLEAR FILM',
  PAPER: 'PAPER',
  'BLUE FILM': 'BLUE FILM',
  'MAMMO BLUE FILM': 'MAMMO BLUE FILM',
  'MAMMO CLEAR FILM': 'MAMMO CLEAR FILM',
  Magnification: 'Magnification',
  REPLICATE: 'REPLICATE',
  BILINEAR: 'BILINEAR',
  CUBIC: 'CUBIC',
  NONE: 'NONE',
  BLACK: 'BLACK',
  WHITE: 'WHITE',
  Border: 'Border',
  Max: 'Max',
  Min: 'Min',
  Empty: 'Empty',

  'Recorded Annotation': 'Lưu chú thích',
  'Auto Record': 'Tự động lưu',
  'All Users': 'Tất cả người dùng',
  'All Series': 'Tất cả series',

  'Open Print failed': 'Lỗi mở trình in ảnh',
  'Cannot print image on MPR, VR protocol.':
    'Không thể in ảnh trên giao thức MPR, VR.',
  'Multiplanar reconstruction (MPR) ': 'Tái tạo đa mặt phẳng (MPR) ',
  'Multiplanar reconstruction (VR) ': 'Tái tạo đa mặt phẳng (VR) ',
  'Something went wrong while trying to restore the previous layout.':
    'Đã xảy ra lỗi khi cố khôi phục bố cục trước đó.',
  'Multiplanar reconstruction (MPR)': 'Tái tạo đa mặt phẳng (MPR)',
  'Cannot create MPR for this DisplaySet since it is not reconstructable.':
    'Không thể dựng MPR cho bộ hiển thị này vì nó không thể tái tạo được.',
  'The display set is currently selected': 'Bộ hiển thị đã được chọn',
  'Data is reconstructing. Do you want to terminate?':
    'Dữ liệu đang được tái tạo. Bạn có chắc muốn kết thúc?',
  'You need to be in a MPR view to use Crosshairs. Click on MPR button in the toolbar to activate it.':
    'Bạn cần ở chế độ xem MPR để sử dụng Vị trí tương quan. Nhấp vào nút MPR trên thanh công cụ để kích hoạt nó.',
  'Capture Error': 'Chụp lỗi',
  'Can not capture image': 'Không thể chụp ảnh',
  'Saved Key Image': 'Đã lưu ảnh key image',
  'Please reload to see the change': 'Vui lòng tải lại để thấy sự thay đổi',
  'Cross Origin Isolation': 'Cách ly nguồn gốc chéo',
  'Cross Origin Isolation is not enabled, volume rendering will not work (e.g., MPR)':
    'Cách ly nguồn gốc chéo không được bật, kết xuất âm lượng sẽ không hoạt động (ví dụ: MPR)',
  'Save Key Image Failed': 'Không lưu được ảnh key image',
  'Please contact admin for any support':
    'Vui lòng liên hệ với quản trị viên để được hỗ trợ',
  'Overlapping Segments': 'Phân đoạn chồng chéo',
  'Overlapping segments detected which is not currently supported':
    'Các phân đoạn chồng chéo hiện không được hỗ trợ',
  'Create Report': 'Tạo báo cáo',
  'Enable auto record annotation?': 'Bật lưu chú thích tự động?',
  'Measurements saved successfully': 'Các phép đo được lưu thành công',
  'Failed to store measurements': 'Không thể lưu trữ các phép đo',
  'No Measurements': 'không có số đo',
  'No Measurements are added to the current Study.':
    'Không có Phép đo nào được thêm vào ca chụp hiện tại.',
  'Thumbnail Double Click': 'Nhấp đúp chuột vào hình thu nhỏ',
  'The selected display sets could not be added to the viewport due to a mismatch in the Hanging Protocol rules.':
    'Không thể thêm bộ hiển thị đã chọn vào chế độ xem do quy tắc giao thức treo không khớp.',
  'Are you sure you want to delete this report?':
    'Bạn có chắc chắn muốn xóa báo cáo này?',
  'This action cannot be undone.': 'Hành động này không thể được hoàn tác.',
  'Delete Report': 'Xóa báo cáo',
  'Report deleted successfully': 'Xóa báo cáo thành công',
  'Failed to delete report': 'Không thể xóa báo cáo',
  'CAD Tool': 'Công cụ CAD',
  'Drag and Drop': 'Kéo và thả',
  'Viewport Not Supported Yet': 'Chế độ xem chưa được hỗ trợ',
  'Change protocol failed': 'Không thể thay đổi giao thức',
  'No series was found that matches the protocol.':
    'Không tìm thấy series phù hợp với giao thức',

  'Cannot display SOPClassId of': 'Không thể hiển thị SOPClassId của',
  yet: 'chưa',
  'Enter your annotation': 'Nhập chú thích',
  'Delete measurement': 'Xoá đo lường',
  'Set Label': 'Đặt tên nhãn',
  'Arrow Annotate': 'Chú thích mũi tên',
  'Ellipse Tool': 'Công cụ hình Elip',
  'Circle Tool': 'Công cụ hình tròn',
  'Calibration Line': 'Đường hiệu chuẩn',
  'Actual Physical distance (mm)': 'Khoảng cách vật lý thực tế (mm)',
  'Instance Number': 'Số ảnh chụp',
  'Bidirectional Tool': 'Thước đo hai chiều',
  'Length Tool': 'Công cụ thước kẻ',
  Warning: 'Cảnh báo',
  'Cannot create VR for this DisplaySet since it is not reconstructable.':
    'Không thể dựng VR cho bộ hiển thị này vì nó không thể tái tạo được.',

  'Update AI result': 'Cập nhật kết quả AI',
  'Invalid image': 'Hình ảnh không hợp lệ',
  'Error Message': 'Thông báo lỗi',

  'CAD Not Supported': 'CAD không được hỗ trợ',
  "Can't delete DICOM": 'Không thể xoá DICOM',
  'Something went wrong': 'Đã xảy ra sự cố',

  Input: 'Đầu vào',
  Output: 'Đầu ra',

  CAD_Findings: 'Phát hiện',
  Conclusion: 'Kết luận',
  Abnormal: 'Bất thường',
  'Select Slice': 'Lựa chọn lát cắt',
  'Select slice to reconstruct': 'Chọn lát cắt để tái tạo lại',
  'Link Expired': 'Đường dẫn đã hết hạn',
  'Not Found': 'Không tìm thấy',
  'Invalid Pass Code': 'Mã khoá không hợp lệ',
  'Pass Code Required': 'Yêu cầu mã khoá',
  'Citizen ID Required': 'Yêu cầu số CMND/CCCD',
  'Invalid Citizen ID': 'CMND/CCCD không hợp lệ',
  'Enter Pass Code': 'Nhập mã khoá',
  'Enter Citizen ID': 'Nhập số CMND/CCCD',
  Submit: 'Xác nhận',
  'CT Ratio': 'Đo tỷ lệ tim ngực',
  'Patient Information': 'Thông tin người bệnh',
  Hotkeys: 'Phím tắt',
  Function: 'Công cụ',
  Shortcut: 'Phím tắt',
  'Reset All': 'Đặt lại tất cả',
  'Hide DICOM Info': 'Ẩn thông tin DICOM',
  'Reset to Defaults': 'Đặt lại về mặc định',
  'Window Preset 0': 'Cài đặt cửa sổ 0',
  'Window Preset 1': 'Cài đặt cửa sổ 1',
  'Window Preset 2': 'Cài đặt cửa sổ 2',
  'Window Preset 3': 'Cài đặt cửa sổ 3',
  'Window Preset 4': 'Cài đặt cửa sổ 4',
  'Window Preset 5': 'Cài đặt cửa sổ 5',
  'Window Preset 6': 'Cài đặt cửa sổ 6',
  'Window Preset 7': 'Cài đặt cửa sổ 7',
  'Window Preset 8': 'Cài đặt cửa sổ 8',
  'Window Preset 9': 'Cài đặt cửa sổ 9',
  'Enter Your Value': 'Nhập giá trị',
  'Reset Annotation': 'Đặt lại chú thích',
  conflictKeys:
    '"{{ conflictLabel }}" đã sử dụng phím tắt "{{ conflictKey }}".',
  'hotkey-modifier':
    'Không thể chỉ xác định các phím bổ trợ (ctrl, alt và shift) làm phím tắt',
  'hotkey-empty': 'Trường không thể trống.',
  disallowedKey: '"{{ pressedKeys }}" không được phép kết hợp phím tắt',
  'Next Image Viewport': 'Khung hình tiếp theo',
  'Previous Image Viewport': 'Khung hình trước đó',
  'First Image': 'Ảnh đầu tiên',
  'Last Image': 'Ảnh cuối cùng',
  Saving: 'Đang lưu',

  General: 'Cài đặt chung',
  'Select server': 'Chọn máy chủ',
  Default: 'Mặc định',
  'These changes require a page reload. Would you like to proceed and refresh the page?':
    'Để áp dụng những thay đổi này, bạn có muốn tiếp tục và làm mới trang không?',

  'CHEST_XRAY.content':
    '<p><strong>VinDr-ChestXR</strong>&nbsp;là một công cụ CAD dùng cho ca chụp X-quang ngực. Nó có thể khoanh vùng 18 loại tổn thương phổ biến trên X-quang ngực.</p><p>Chẩn đoán được đưa ra dựa trên nửa triệu nghiên cứu các ca chụp X-quang ngực từ nguồn công khai và một số bệnh viện ở Việt Nam. Bộ khoanh vùng tổn thương và nhãn bệnh được thực hiện bởi các bác sĩ X-quang hàng đầu của Việt Nam. Độ chính xác trên 90% đối với hầu hết các bệnh và kết quả phát hiện.</p>',
  'CHEST_XRAY.input':
    '<ul><li><p>Ảnh đầu vào cho VinDr-ChestXR là ảnh X-quang DICOM của ngực ở chế độ sau-trước (<strong>PA</strong>) hoặc trước-sau (<strong>AP</strong>)</p></li><li><p>Áp dụng cho người bệnh trên 16 tuổi</p></li><li><p>Danh sách các thuộc tính DICOM bắt buộc và giá trị tương ứng cho mỗi thuộc tính như sau:</p><ul><li><p>Modality(0008, 0060): CR hoặc DX hoặc DR</p></li><li><p>PhotometricInterpretation(0028, 0004): Không được bỏ trống</p></li><li><p>PresentationIntentType(0008, 00068): FOR PRESENTATION</p></li></ul></li></ul>',
  'CHEST_XRAY.output':
    '<p>Kết quả phân tích VinDr-ChestXR bao gồm:</p><ul><li><p>Phát hiện tổn thương: mỗi tổn thương trên hình ảnh được bao quanh bởi một hình chữ nhật và được dán nhãn bằng một trong các loại tổn thương được chỉ ra trong danh sách dưới đây:</p><ul><li><p>Giãn động mạch chủ</p></li><li><p>Xẹp phổi</p></li><li><p>Vôi hóa</p></li><li><p>Bóng tim to</p></li><li><p>Gãy xương đòn</p></li><li><p>Đông đặc</p></li><li><p>Khí phế thũng</p></li><li><p>Giãn động mạch phổi</p></li><li><p>Thâm nhiễm</p></li><li><p>Dày tổ chức kẽ</p></li><li><p>Nốt/Khối</p></li><li><p>Hình mờ</p></li><li><p>Tràn dịch màng phổi</p></li><li><p>Dày màng phổi</p></li><li><p>Tràn khí màng phổi</p></li><li <p>Xơ phổi</p></li><li><p>Gãy xương sườn</p></li><li><p>Tổn thương khác</p></li></ul></li><li><p>Phân loại hình ảnh: mỗi hình ảnh được phân loại theo mức độ bình thường/bất thường</p></li></ul>',
  'SPINE_XR.content':
    '<p><strong>VinDr-SpineXR</strong> là một công cụ CAD dùng cho ca chụp X-quang cột sống, có thể phân loại chụp X-quang cột sống là bình thường hay bất thường. Hệ thống cũng có thể khoanh vùng <strong>6</strong> loại tổn thương phổ biến trên hình ảnh.</p><p>Chẩn đoán của VinDr-SpineXR được đưa ra dựa trên tập dữ liệu quy mô lớn khoảng <strong>10.000</strong> ca chụp được thu thập từ một số bệnh viện ở Việt Nam, trong đó khoanh vùng tổn thương và nhãn bệnh được thực hiện bởi các bác sĩ X-quang hàng đầu của Việt Nam. Độ chính xác của phát hiện bất thường là khoảng <strong>60%</strong> về mAP@0.2.</p>',
  'SPINE_XR.input':
    '<ul><li>Ảnh đầu vào của VinDr-SpineXR là ảnh X-quang DICOM cột sống cổ, ngực hoặc thắt lưng ở cả chế độ sau-trước (<strong>PA</strong>) hoặc trước-sau (<strong>AP</strong>)</li><li>Áp dụng cho người bệnh trên 16 tuổi</li><li>Danh sách các thuộc tính DICOM bắt buộc và giá trị tương ứng cho mỗi thuộc tính như sau:<ul><li>Modality(0008, 0060): CR hoặc DX hoặc DR</li><li>PhotometricInterpretation(0028, 0004): Không được bỏ trống</li><li>PresentationIntentType(0008, 00068): FOR PRESENTATION</li><li>RescaleIntercept(0028, 1052): Không được bỏ trống</li><li>RescaleSlope(0028,1053): Không được bỏ trống </li><li>WindowCenter(0028,1050): Không được bỏ trống</li><li>WindowWidth(0028,1051): Không được bỏ trống </li></ul></li></ul>',
  'SPINE_XR.output':
    'Kết quả phân tích của VinDr-ChestXR bao gồm:<ul><li>Phát hiện tổn thương: mỗi tổn thương trên hình ảnh được bao quanh bởi một hình chữ nhật và được dán nhãn bằng một trong các loại tổn thương được chỉ ra trong danh sách dưới đây:<ul><li>Hẹp khe đĩa đệm</li><li>Hẹp lỗ tiếp hợp</li><li>Gai xương</li><li>Trượt đốt sống</li><li>Vật liệu phẫu thuật</li><li>Xẹp đốt sống</li></ul></li><li>Phân loại ảnh: mỗi ảnh được phân loại theo mức độ bình thường/bất thường</li></ul>Lưu ý có thể có trường hợp phân loại ảnh bất thường nhưng không có vị trí tổn thương do tổn thương đó có thể không thuộc 6 loại đã nói ở trên.',
  'MAMMOGRAPHY.content':
    '<p><strong>VinDr-Mammo</strong>&nbsp;là một công cụ CAD&nbsp;dùng cho X-quang tuyến vú. Có thể phân loại chụp nhũ ảnh thành 3 cấp độ BI-RADS (Breast Imaging-Reporting and Data System) và 4 loại mật độ vú. Hệ thống cũng có thể khoanh vùng 3 loại bất thường thường gặp trên nhũ ảnh.&nbsp;&nbsp;</p><p>Chẩn đoán của VinDr-Mammo được đưa ra dựa trên khoảng 50.000 ca chụp được thu thập từ nhiều bệnh viện tại Việt Nam. Các khoanh vùng tổn thương và nhãn bệnh được thực hiện bởi các bác sĩ X-quang hàng đầu của Việt Nam. Độ chính xác khi phân loại BI-RADS là trên 80%.</p>',
  'MAMMOGRAPHY.input':
    '<ul><li>Ảnh đầu vào của VinDr-Mammo là ảnh X-quang DICOM bao gồm ít nhất <strong>một trong bốn</strong> chế độ xem sau: Left MLO (Mediolateral Oblique), Left CC (Craniocaudal), Right  MLO, Right CC</li><li>Danh sách các thuộc tính DICOM bắt buộc và giá trị tương ứng cho mỗi thuộc tính như sau:<ul><li>Modality(0008, 0060): MG</li><li>BodyPartExamined(0018, 0015): BREAST</li><li>Laterality(0020,0060 ): Ít nhất một trong hai thẻ phải bằng “L” hoặc “R”</li><li>ImageLaterality(0020,0062): Ít nhất một trong hai thẻ phải bằng “L” hoặc “R”</li><li>ViewPosition(0018 0051): “CC” hoặc “MLO”</li><li>PhotometricInterpretation(0028, 0004): Không được bỏ trống</li><li>PresentationIntentType( 0008, 00068): FOR PRESENTATION</li><li>RescaleIntercept(0028, 1052): Không được bỏ trống</li><li>RescaleSlope(0028,1053): Không được bỏ trống</li><li>WindowCenter( 0028,1050): Không được bỏ trống </li><li>WindowWidth(0028,1051): Không được bỏ trống </li><li>PixelPaddingValue(0028,0120): Không được bỏ trống </li></ul></li></ul>',
  'MAMMOGRAPHY.output':
    '<p>Kết quả phân tích của VinDr-Mammo bao gồm:</p><ul><li><p>Phát hiện tổn thương: mỗi tổn thương trên hình ảnh được bao quanh bởi một hình chữ nhật và được dán nhãn bằng một trong các loại tổn thương được chỉ ra trong danh sách dưới đây:</p><ul><li><p>Vôi hóa</p></li><li><p>Hạch</p></li><li><p>Tổn thương dạng khối</p></li></ul></li><li><p>Phân loại hình ảnh:</p><ul><li><p>Kết quả của VinDr-Mammo cũng bao gồm phân loại BI-RADS và phân loại mật độ cho từng bên vú</p></li><li><p>Các phân loại BI-RADS 1, BI-RADS 2/3 và BI-RADS 4/5 tương ứng với các trạng thái bình thường, lành tính và nghi ngờ ác tính</p></li><li><p>Phân loại mật độ vú gồn có Density A/ Density B/ Density C/ Density D </p></li></ul></li></ul>',
  'LUNG_CT.content':
    '<p><strong>VinDr-ChestCT</strong>&nbsp;là một công cụ CAD&nbsp;dùng cho ca chụp CT ngực. Có khả năng khoanh vùng 04 loại bất thường thường gặp trên phim chụp CT ngực.</p><p>Chẩn đoán được đưa ra dựa trên khoảng 30.000 ca chụp được thu thập từ các nguồn công khai và một số bệnh viện tại Việt Nam. Chú thích khoanh vùng tổn thương và nhãn bệnh được thực hiện bởi các bác sĩ chẩn đoán hình ảnh hàng đầu của Việt Nam.</p>',
  'LUNG_CT.input':
    '<ul><li><p>Ảnh đầu vào của VinDr-ChestCT là series của ca chụp CT ngực ở định dạng DICOM trên mặt phẳng đứng</p></li><li><p>Series phải có tối thiểu 10 ảnh</p></li><li><p>Áp dụng cho người bệnh trên 16 tuổi</p></li><li><p>Danh sách các thuộc tính DICOM bắt buộc và giá trị tương ứng cho mỗi thuộc tính như sau:</p><ul><li><p>Modality(0008, 0060): CT</p></li><li><p>BodyPartExamined(0018, 0015) : “CHEST” hoặc “THORAX”</p></li><li><p>RescaleIntercept(0028, 1052): Không được bỏ trống</p></li><li><p>RescaleSlope(0028, 1053): Không được bỏ trống </p></li><li><p>WindowCenter(0028,1050): Không được bỏ trống </p></li><li><p>WindowWidth(0028,1051) : Không được bỏ trống </p></li><li><p>ImagePositionPatient(0020, 0032): Không được bỏ trống </p></li></ul></li></ul>',
  'LUNG_CT.output':
    '<p>Kết quả phân tích của VinDr-ChestCT bao gồm:</p><ul><li><p>Phát hiện tổn thương: mỗi tổn thương trên hình ảnh được bao quanh bởi một hình chữ nhật và được dán nhãn bằng một trong các loại tổn thương được chỉ ra trong danh sách dưới đây:</p><ul><li><p>Đông đặc</p></li><li><p>Hạch trung thất</p></li><li><p>Nốt/Khối</p></li><li><p>Tràn dịch màng phổi</p></li></ul></li><li><p>Phân loại hình ảnh: mỗi series được phân loại theo mức độ bình thường/bất thường</p></li></ul>',
  'LIVER_CT.content':
    '<p><strong>VinDr-LiverCT</strong>&nbsp;là một công cụ CAD dùng cho ca chụp CT bụng. Có thể khoanh vùng 04 loại bất thường về gan phổ biến trên phim chụp CT bụng.&nbsp;&nbsp;</p><p>Chẩn đoán được đưa ra dựa trên 10.000 ca chụp được thu thập từ cả nguồn công khai và một số bệnh viện tại Việt Nam. Chú thích khoanh vùng tổn thương và nhãn bệnh được thực hiện bởi các bác sĩ chẩn đoán hình ảnh hàng đầu của Việt Nam.<p>',
  'LIVER_CT.input':
    '<ul><li><p>Ảnh đầu vào của VinDr-LiverCT là series của ca chụp CT vùng bụng ở định dạng DICOM trên mặt phẳng đứng</p></li><li><p>Series phải có tối thiểu 10 ảnh</p></li><li><p>Áp dụng cho người bệnh trên 16 tuổi</p></li><li><p>VinDr-LiverCT sẽ ưu tiên phân tích series chụp tĩnh mạch có tiêm thuốc cản quang. Nếu không có series tăng cường độ tương phản thì có thể thay thế bằng series chụp động mạch</p></li><li><p>Danh sách các thuộc tính DICOM bắt buộc và giá trị tương ứng cho mỗi thuộc tính như sau:</p><ul><li><p>Modality(0008, 0060): CT</p></li><li><p>BodyPartExamined(0018, 0015) : “ABDOMEN”</p></li><li><p>RescaleIntercept(0028, 1052): Không được bỏ trống</p></li><li><p>RescaleSlope(0028,1053): Không được bỏ trống </p></li><li><p>WindowCenter(0028,1050): Không được bỏ trống </p></li><li><p>WindowWidth(0028,1051): Không được bỏ trống </p></li><li><p>SliceThickness(0018,0050): Không được bỏ trống</p></li></ul></li></ul>',
  'LIVER_CT.output':
    '<p>Kết quả phân tích của VinDr-LiverCT bao gồm:</p><ul><li><p>Phát hiện tổn thương: mỗi tổn thương trên hình ảnh được bao quanh bởi một hình chữ nhật và được dán nhãn bằng một trong các loại tổn thương được chỉ ra trong danh sách dưới đây:</p><ul><li><p>Giãn đường mật</p></li><li><p>Vôi hóa</p></li><li><p>Tổn thương dạng nang</p></li><li><p>Khối</p></li></ul></li><li><p>Phân loại hình ảnh: mỗi series được phân loại theo các tiêu chí gan bình thường/bất thường/nhiễm mỡ/gan xơ</p></li></ul>',
  'BRAIN_CT.content':
    '<p><strong>VinDr-BrainCT</strong>&nbsp;là một công cụ CAD dung cho ca chụp CT não. Có khả năng phân đoạn các tổn thương xuất huyết trên phim chụp CT não.</p><p>Chẩn đoán của VinDr-BrainCT được đưa ra dựa trên khoảng 30.000 ca chụp được thu thập từ cả các nguồn công khai và một số bệnh viện ở Việt Nam. Việc phân đoạn (trên hình ảnh 3D) và ghi nhãn bệnh được thực hiện bởi các bác sĩ chẩn đoán hình ảnh hàng đầu của Việt Nam.</p>',
  'BRAIN_CT.input':
    '<ul><li><p>Ảnh đầu vào của VinDr-BrainCT là series của ca chụp CT não ở định dạng DICOM trên mặt phẳng đứng</p></li><li><p>Series phải có tối thiểu 10 ảnh</p></li><li><p>Áp dụng cho người bệnh trên 16 tuổi</p></li><li><p>Danh sách các thuộc tính DICOM bắt buộc và giá trị tương ứng cho mỗi thuộc tính như sau:</p><ul><li><p>Modality(0008, 0060): CT</p></li><li><p>BodyPartExamined(0018, 0015) : “BRAIN” hoặc “HEAD”</p></li><li><p>Contrast/BolusAgent(0018, 0010): Không tồn tại</p></li><li><p>Convolutionkernel(0018 ,1210): H31s”, “Hr40f”, “BrainA”, “STANDARD”, “SA” hoặc “SB”</p></li><li><p>SliceThickness(0018,0050): “5.0” , “3.0” hoặc “1.0”</p></li><li><p>RescaleIntercept(0028, 1052): Không được bỏ trống</p></li><li><p>RescaleSlope(0028, 1053): Không được bỏ trống </p></li><li><p>WindowCenter(0028,1050): Không được bỏ trống </p></li><li><p>WindowWidth(0028,1051) : Không được bỏ trống </p></li></ul></li></ul>',
  'BRAIN_CT.output':
    '<p>Kết quả phân tích của VinDr-BrainCT bao gồm:</p><ul><li><p>Phát hiện tổn thương: mỗi tổn thương xuất huyết trên hình ảnh được bao quanh bởi một phân đoạn</p></li><li <p>Phân loại hình ảnh: mỗi loạt ảnh được phân loại theo mức độ bình thường/bất thường</p></li></ul>',
  'BRAIN_MRI.content':
    '<p data-renderer-start-pos="13185"><strong data-renderer-mark="true">VinDr-BrainMR</strong>&nbsp;là một công cụ CAD&nbsp;dùng cho ca chụp MRI não. Có thể khoanh vùng 14 loại bất thường phổ biến khi chụp MRI não.&nbsp;</p><p data-renderer-start-pos="13321">Chẩn đoán đưa ra dựa trên nghiên cứu khoảng 3.000 ca chụp được thu thập từ cả nguồn công khai và một số bệnh viện tại Việt Nam. Chú thích khoanh vùng tổn thương và nhãn bệnh được thực hiện bởi các bác sĩ chẩn đoán hình ảnh hàng đầu của Việt Nam.&nbsp;</p>',
  'BRAIN_MRI.input':
    '<ul><li><p>Ảnh đầu vào của VinDr-BrainMR series của ca chụp MR não ở định dạng DICOM ở trình tự FLAIR và trên mặt phẳng đứng</p></li><li><p>Series phải có tối thiểu 10 ảnh</p></li><li><p>Áp dụng cho người bệnh trên 16 tuổi</p></li><li><p>Danh sách các thuộc tính DICOM bắt buộc và giá trị tương ứng cho mỗi thuộc tính như sau:</p><ul><li><p>Modality(0008, 0060): MR</p></li><li><p>BodyPartExamined(0018, 0015) : “BRAIN” hoặc “HEAD”</p></li><li><p>RescaleIntercept(0028, 1052): Không được bỏ trống</p></li><li><p>RescaleSlope(0028, 1053): Không được bỏ trống</p></li><li><p>WindowCenter(0028,1050): Không được bỏ trống</p></li><li><p>WindowWidth(0028,1051) : Không được bỏ trống</p></li><li><p>ImagePositionPatient(0020, 0032): Không được trống</p></li></ul></li></ul>',
  'BRAIN_MRI.output':
    '<p>Kết quả phân tích của VinDr-BrainMR bao gồm:</p><ul><li><p>Phát hiện tổn thương: mỗi tổn thương trên hình ảnh được bao quanh bởi một hình chữ nhật và được dán nhãn bằng một trong các loại tổn thương được chỉ ra trong danh sách dưới đây:</p><ul><li><p>Dị dạng thông động tĩnh mạch</p></li><li><p>U máu thể hang</p></li><li><p>Teo não</p></li><li><p>Phù não</p></li><li><p>Tổn thương dịch hóa</p></li><li><p>Tổn thương dạng nang</p></li><li><p>Thoái hóa myelin</p></li><li><p>Tăng thần kinh đệm</p></li><li><p>Thâm nhiễm</p></li><li><p>Hiệu ứng khối</p></li><li><p>Nốt/khối</p></li><li><p>Đè đẩy đường giữa</p></li><li><p>Tổn thương xoang</p></li><li><p>Giãn não thất</p></li></ul></li><li><p>Phân loại hình ảnh: mỗi series được phân loại theo mức độ bình thường/bất thường</p></li></ul>',
};
